import React from "react";

import { useParams } from "react-router-dom";

import {
  TradeProposalBundleId,
  TradeProposalId,
} from "@fartherfinance/frontend/api/Investment/types";

import AdvisorContainer from "../AdvisorContainer";
import AdvisorContentContainer from "../AdvisorContentContainer";
import FinOpsLayout from "@src/multiCustodian/components/Advisor/FinanicalOperations/FinOpsLayout";
import ProposalDetails from "@src/multiCustodian/components/Advisor/FinanicalOperations/Proposals/ProposalDetails";

interface Params {
  bundleId: TradeProposalBundleId;
  proposalId: TradeProposalId;
}

const TradeProposalBundleProposalDetail: React.FC = () => {
  const { proposalId } = useParams<Params>();

  return (
    <AdvisorContainer>
      <AdvisorContentContainer heroTitle={"Financial Operations"}>
        <FinOpsLayout>
          <ProposalDetails tradeProposalId={proposalId} />
        </FinOpsLayout>
      </AdvisorContentContainer>
    </AdvisorContainer>
  );
};

export default TradeProposalBundleProposalDetail;
